import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const cseChipGroup = {
  columnGap: css`var(--cse-chip-group-column-gap, ${csSpacing.spacing05})`,
  rowGap: css`var(--cse-chip-group-row-gap, ${csSpacing.spacing05})`,
}

export const groupStyle: CSSResult = css`
    .cse-chip-group {
        column-gap: ${cseChipGroup.columnGap};
        display: flex;
        row-gap: ${cseChipGroup.rowGap};
    }

    .cse-chip-group.scroll:not(.wrap) {
        overflow: auto;
        padding-block: 0 ${csSpacing.spacing02};
    }

    .wrap {
        flex-wrap: wrap;
    }

    .align-right {
        justify-content: flex-end;
    }
`
